import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import ServiceIntro from './components/ServiceIntro';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '被护专家',
    url: 'https://beiziganxi.com',
    description: '专业被芯干洗护理品牌，提供蚕丝被、羽绒被、美女被等高端被芯的专业干洗护理服务',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://beiziganxi.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEOHead
        title="美女被干洗护理全攻略｜专业干洗服务推荐"
        description="美女被干洗护理怎么做？本页详解高档美女被、蚕丝被、羽绒被的专业干洗流程、注意事项及保养技巧，帮助您延长被芯使用寿命，保持蓬松柔软，推荐靠谱干洗服务商。"
        keywords="美女被干洗,被子干洗,蚕丝被护理,羽绒被干洗,被芯清洁,被子保养,专业洗被服务"
        schema={schema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <ServiceIntro />
        <CategoryGrid />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}